document.addEventListener("turbo:load", function() {

  $('.js-single-gallery-slider').each(function(){
    const currentSlider = $(this);

    currentSlider.slick({
      slidesToShow: 1,
      dots: false,
      nextArrow: currentSlider.next().find('.gallery-image-container__nextArrow'),
      prevArrow: currentSlider.next().find('.gallery-image-container__prevArrow'),
    });
    })
});
